import React, { useEffect, useState } from 'react';
import Pen from '../Pen/Pen';
import NavBar from '../NavBar/NavBar'
import firebase from 'firebase'
import Loader from '../Loader';
export default function Pens() {


    const [state, setState] = useState({
        userData: [],
        pens: [],
        currentPage: 0,
        type: "new",
        is_loading : true
    })

    const [filter, setFilter] = useState("popular")

    const [pensData, setPensData] = useState([])

useEffect(() => {
    getPens("views")
},[])


const getPens = (query) => {
    setPensData([])
    firebase.firestore().collection("pens")
    .orderBy(query, "desc")
    .limit(10)
    .get().then(snaps => {
        snaps.forEach(pen => {
            setPensData(prev => [...prev, {
                ...pen.data()}])
        })
    }).then(() => setState({
        ...state,
        is_loading : false
    }))
} 

    const getMostLovedPens = () => {
        if(filter === "loved") return
        setState({
            ...state,
            is_loading : true
        })
        setFilter("loved")
        getPens("love_count")
    }

    const getMostPopularPens = () => {
        if(filter === "popular") return
        setState({
            ...state,
            is_loading : true
        })
        setFilter("popular")
        getPens("views") 
    }

    const getUserPens = () => {}

    var pensList = pensData.map(pen => {

        return (
            <Pen
                key={pen.pen_id}
                id={pen.pen_id}
                penData={pen}
                />
        );
    })
        // }
return (
    <div>
        <NavBar/>
        <div className="pensView">
            <div className="pens-sizing-container">
                <div className="pensHeader" style={!state.is_loading ? {
                    borderBottom : "3px solid #faba0c", } : {}}>
                    <h1>Explore Pens</h1>
                    <h4>
                        {/* View My Pens<i className="fa fa-arrow-right"></i> */}
                    </h4>
                </div>
                    {state.is_loading && <Loader /> }
                <div className="filterPens my-5">
                    <button onClick={() => getMostPopularPens()} style={{ color: filter === "popular" ? "white" : "#8F8F8F" }}>Most Popular</button>
                    <button onClick={() => getMostLovedPens()} style={{ color: filter === "loved" ? "white" : "#8F8F8F" }}>Most Loved</button>
                    {state.userData.userid ? (
                        <button onClick={() => getUserPens()} style={{ color: state.filter === "my" ? "white" : null }}>My Pens</button>
                    ) : (
                        null
                    )}
                </div>
                <div className="pensDisplay">
                    { pensList }
                </div>
                {/* <div className="paginationButtons">
                    <button className="nextButton" style={{ display: state.currentPage === 0 ? "none" : "block" }} onClick={() => getPrev()}><i className="fa fa-angle-left"></i>Prev</button>
                    {
                        !state.is_loading &&
                        <button className="nextButton" onClick={() => nextPage()}>Next<i className="fa fa-angle-right"></i></button>
                    }
                </div> */}
            </div>
        </div>
    </div>
)
    }



// WEBPACK FOOTER //
// ./src/components/Pens/Pens.js